"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Superscript = function Superscript(_ref) {
  var text = _ref.text,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["text"]);
  return /*#__PURE__*/_react.default.createElement("sup", (0, _extends2.default)({
    "aria-hidden": "true"
  }, rest), text);
};

Superscript.propTypes = {
  /** Customizable text to render in the superscript tag. This text is hidden from assistive technology. */
  text: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
Superscript.defaultProps = {
  text: 1
};
var _default = Superscript;
exports.default = _default;